export const EMPTY_SELECTED_AGENT_IDS: readonly string[] = [];
